(function($){
    $(function(){  //document.ready

        $("#shopify-section-sidebar-filter .sidebar-link-lv1").addClass("open");
      
      
      
      
      	
		$( "#shopify-product-reviews" ).appendTo( $( "#conteneureviewsproduct" ) );
      
      
      
      
      strtags = $('div.recommendedfor').text();
   if($.trim(strtags) === "") {
     $('div.recommendedfor').hide();
   }
      
      $(document).on('click', '.plus.button', function(e) {
        setTimeout(function(){
    $(".update.btn").trigger('click');
        },1500); 
});
      
      
      $(document).on('click', '.minus.button', function(e) {
        setTimeout(function(){
    $(".update.btn").trigger('click');
        },1500); 
});


      
      $(document).on('click', '#buttonsignuployalty', function(e) {
       		$([document.documentElement, document.body]).animate({
        	scrollTop: $("#contact_form").offset().top
    		}, 2000);
});
      
      
      
      
      //Masquer les filtres vides
      var sizezero = $('.sidebar-tags:eq(0) ul li').length;
      var sizeone = $('.sidebar-tags:eq(1) ul li').length;
      var sizetwo = $('.sidebar-tags:eq(2) ul li').length;
      var sizethree = $('.sidebar-tags:eq(3) ul li').length;
      var sizefour = $('.sidebar-tags:eq(4) ul li').length;
      var sizefive = $('.sidebar-tags:eq(5) ul li').length;
      var sizesix = $('.sidebar-tags:eq(6) ul li').length;
      var sizeseven = $('.sidebar-tags:eq(7) ul li').length;
      var sizeheight = $('.sidebar-tags:eq(8) ul li').length;
      
      
      if (sizezero === 0) {
    $('.sidebar-tags:eq(0)').hide();
      }  
      if (sizeone === 0) {
    $('.sidebar-tags:eq(1)').hide();
      } 
      if (sizetwo === 0) {
    $('.sidebar-tags:eq(2)').hide();
      } 
      if (sizethree === 0) {
    $('.sidebar-tags:eq(3)').hide();
      } 
      if (sizefour === 0) {
    $('.sidebar-tags:eq(4)').hide();
      } 
      if (sizefive === 0) {
    $('.sidebar-tags:eq(5)').hide();
      } 
      if (sizesix === 0) {
    $('.sidebar-tags:eq(6)').hide();
      } 
      if (sizeseven === 0) {
    $('.sidebar-tags:eq(7)').hide();
      } 
      if (sizeheight === 0) {
    $('.sidebar-tags:eq(8)').hide();
      } 
      
    });

    //Functions, Plugins, Etc.. Here
    //(does not wait for DOM READY STATE) 
  

})(jQuery);